import React, { Component } from 'react';
import { ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';

class Agreement extends Component {
  render() {
    const { agreement } = this.props;

    if (this.props.source === 'dashboard') {
      return (
        <div className="dash-agreement" onClick={this.props.handleClick}>
          <div className="title">{agreement.name}</div>
          <div className="details">{agreement.comments}</div>
        </div>
      );
    } else {
      return (
        <div className="agreement" onClick={this.props.handleClick}>
          <OverlayTrigger
            overlay={<Tooltip id="tooltip-split">{agreement.name}</Tooltip>}
            placement="top"
          >
            <div className="title">{agreement.name}</div>
          </OverlayTrigger>
          <div className="details">{agreement.comments}</div>
          <ProgressBar now={100} bsStyle="success" label="100% Complete" />
          {/* <div className="link">
                        <a>View Agreement</a>
                    </div> */}
        </div>
      );
    }
  }
}

export default Agreement;



// WEBPACK FOOTER //
// src/components/Agreements/Agreement.jsx